import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, Notice } from '@calm-web/design-system';

import messages from './messages';

export const Link = styled.a`
	${fontWeight(FontWeights.Medium)};
	text-decoration: underline;
	cursor: pointer;
`;

export const NoticeContainer = styled(Notice)`
	margin-top: 1rem;
	background-color: ${palette('blue2')};
	${fontWeight(FontWeights.Medium)}
`;

const B2bUpsell = () => {
	const { formatMessage } = useIntl();
	const b2bUrl = 'https://health.calm.com/';

	return (
		<NoticeContainer describedBy="gift-card-quantity">
			{formatMessage(messages.b2bUpsellMessage, {
				b2bLink: (...chunks: ReactNode[]) => (
					<Link href={b2bUrl} target="_blank" rel="noopener noreferrer">
						{chunks}
					</Link>
				),
			})}
		</NoticeContainer>
	);
};

export default B2bUpsell;
